


import { useService } from '@infonova/framework/lib/react/hooks/useService';
import React, { useEffect, useState } from 'react';
// import { ToastContainer } from 'react-toastify';
import { ExternalServiceConfiguration } from '../../configuration/ExternalServiceConfiguration';
import { DraftOrderResponse } from '../../configuration/integration-service/types/DraftOrderResponse';

import { BaseComponent } from '../base/BaseComponent';


import { DraftOrderComponent } from '../orders/DraftOrderComponent';
import Button from '../button/button';



export const TopBar = () => {
    const [initialised, setInitialised] = useState(false);
    const [open, setOpen] = useState(false);
    const [ignoreNavigationHints, setIgnoreNavigationHints] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const [wizardMap, setWizardMap] = useState(null);

    const [saveEnabled, setSaveEnabled] = useState(false);

    const [customerAccountId, setCustomerAccountId] = useState(null);
    const [createDraftUrl, setCreateDraftUrl] = useState(null);

    const [cartId, setCartId] = useState(null);

    const [draftOrderId, setDraftOrderId] = useState(null);
    const [accountId, setAccountId] = useState(null);
    const [opportunityId, setOpportunityId] = useState(null);
    const [quoteId, setQuoteId] = useState(null);

    const [salesForceHandler, setSalesForceHandler] = useState(null);


    const salesforceService = useService(ExternalServiceConfiguration.SalesforceService);
    const integrationService = useService(ExternalServiceConfiguration.IntegrationService);



    useEffect(() => {
        init();

        const query = new URLSearchParams(window.location.href);
        if (query.get("ignoreNavigationHints") && query.get("ignoreNavigationHints") == "true")
            setIgnoreNavigationHints(true);
 
    });

    useEffect(() => {
        let initialiseMsg = { name: "WizardStateRequest", value: '' }
        salesforceService.sendSalesforceMessage(initialiseMsg);
    }, []);

    const init = () => {
        setSalesForceHandler(salesforceService.addSalesforceMessageHandler((msg) => {
            if (msg.name == 'StateChange') {
                if (!msg.value.steps || msg.value.steps.length == 0) {
                    return;
                }

                setWizardMap(msg.value);

                // If we get a shopping cart id and we're not working on a current draft, then we are in the product wizard. Store the cart id and wait for Save to be clicked
                if (quoteId && !draftOrderId && msg.value.shoppingCartId) {
                    setCartId(msg.value.shoppingCartId);
                    setSaveEnabled(true);
                }
            } else if (msg.name === "UI") {
                // Message UI click - is a message indicating that the user has click on the infonova UI frame (i.e. outside of this component)
                if (msg.value.type == 'click') {
                    setOpen(false);
                }
            }
        }));
    }

    useEffect( () => {
        if (!wizardMap || initialised) {
            return;
        }

        setSaveEnabled(true);
        setInitialised(true);

        let allEnabled = wizardMap.steps.every((step => step.isSKipped || step.nextEnabled == true));
        if (allEnabled) {
            setTimeout(() => {
                setStepIndex(wizardMap.steps.length - 1);
                let navigationMsg = { name: "Navigation", value: wizardMap.steps.length - 1 };
                salesforceService.sendSalesforceMessage(navigationMsg);
            }, 500);
        }
    }, [wizardMap])

    const createDraftOrder = async () => {
        salesforceService.sendSalesforceMessage({
            name: "StateChange",
            value: {
                "type": "stateLoading"
            }
        });

        try {
            const draftResponse = await integrationService.createDraft(createDraftUrl,
            {
                accountId: accountId,
                customerAccountId: customerAccountId,
                opportunityId: opportunityId,
                quoteId: quoteId,
                shoppingCartId: cartId
            });

            draftOrderCreated(draftResponse);
        } catch (err) {
            console.debug('Failed on cart creation');
        }
    }


    useEffect(() => {
        const accountGetHandler = salesforceService.addSalesforceMessageHandler((resp: any) => {
            if (resp.name === "accountGetResponse") {
                setCreateDraftUrl(resp.data.createDraftUrl);
                setDraftOrderId(resp.data.draftOrderId);
                setAccountId(resp.data.accountId);
                setOpportunityId(resp.data.opportunityId);
                setQuoteId(resp.data.quoteId);
                setCustomerAccountId(resp.data.customerAccountId);
            }

            // salesforceService.removeSalesforceMessageHandler(accountGetHandler);
        });

        salesforceService.sendSalesforceMessage({ name: "CustomerAccount", value: "GET" });
        // salesforceService.removeSalesforceMessageHandler()
    }, []);


    const toggleOpen = () => {
        setOpen(!open);
    }

    const moveStep = (direction) => {
        const newStepIndex = findUnskippedStep(direction);

        let enabled = true;

        if (enabled) {
            setStepIndex(newStepIndex)
            let navigationMsg = { name: "Navigation", value: newStepIndex }
            salesforceService.sendSalesforceMessage(navigationMsg);
        }

        return enabled;
    }

    const previousStep = () => {
        moveStep(-1);
    }

    const nextStep = () => {
        moveStep(1);
    }

    const saveDraft = () => {
        if (draftOrderId) {
            let navigationMsg = { name: "OrderAction", value: 'save' }
            salesforceService.sendSalesforceMessage(navigationMsg);
        } else if (cartId) {
            // Reset the top bar
            setSaveEnabled(false);
            setInitialised(false);
            setCartId(null);
            setWizardMap(null);
            setStepIndex(0);

            // init();

            createDraftOrder();
        }

        // const notify = () => toast("Draft Order Saved");

    }

    const findUnskippedStep = (direction) => {
        let currentStep = stepIndex + direction;

        while (currentStep >= 0 && currentStep < wizardMap.steps.length) {
            if (wizardMap.steps[currentStep].isSkipped) {
                currentStep = currentStep + direction;
            } else {
                break;
            }
        }

        return currentStep < 0 ? stepIndex : currentStep < wizardMap.steps.length ? currentStep : stepIndex;
    };

    const isEnabled = (btnType: string): boolean => {
        if (!wizardMap) {
            return false;
        }

        if (btnType === 'nextStep') {
            let checkIndex = findUnskippedStep(1);
            if (checkIndex != stepIndex && checkIndex < wizardMap.steps.length) {
                return ignoreNavigationHints ? true : wizardMap.steps[stepIndex].nextEnabled;
            }
        } else if (btnType === 'prevStep') {
            let checkIndex = findUnskippedStep(-1);
            if (checkIndex != stepIndex && checkIndex > 0) {
                return ignoreNavigationHints ? true : wizardMap.steps[stepIndex].prevEnabled;
            }
        }

        return false;
    }

    const callback = (evt) => {
        setOpen(false);
    }
    // render() {
    //     if( !this.state['ready']) {
    //         return <div>Loading</div>
    //     }

    const focusInCurrentTarget = ({ relatedTarget, currentTarget }) => {
        if (relatedTarget === null) return false;

        var node = relatedTarget.parentNode;

        while (node !== null) {
            if (node === currentTarget) return true;
            node = node.parentNode;
        }

        return false;
    }

    const draftOrderCreated = (draftOrderResponse: DraftOrderResponse) => {
        setDraftOrderId(draftOrderResponse.draftOrderId);
        salesforceService.sendSalesforceMessage({
            name: "DataChange", value: {
                "type": "DraftOrderCreated",
                "draftOrderId": draftOrderResponse.draftOrderId,
                "billingAccountId": draftOrderResponse.billingAccountId
            }
        });
    }


    const onBlur = (event) => {
        if (!open) {
            return;
        }
        let parentNode = event.target.parentNode;
        while (parentNode != null) {
            if (parentNode.classList?.contains('appguard')) {
                return;
            }
            parentNode = parentNode.parentNode;
        }
        
        if (!focusInCurrentTarget(event)) {
            setOpen(false);
        }
    }

    return (
        <div onBlur={onBlur} className={'topBar ' + (open ? "topBarOpen" : "")} >
            <div className="appguard" style={{ width: "fit-content", height: "fit-content" }}>
                {/* <View
                style={[
                    styles.container,
                    {
                        flexDirection: 'row',
                    },
                ]}> */}
                {draftOrderId && <Button onClick={toggleOpen} className='btn btn--oval btn--colored btn--small'>Assign Account</Button>}
                {!draftOrderId && createDraftUrl && <DraftOrderComponent
                    createDraftUrl={createDraftUrl}
                    accountId={accountId}
                    customerAccountId={customerAccountId}
                    opportunityId={opportunityId}
                    quoteId={quoteId}
                    callback={draftOrderCreated} >
                </DraftOrderComponent>}
                <Button onClick={previousStep} disabled={!isEnabled('prevStep')} className='btn btn--oval btn--colored btn--small'>Previous</Button>
                <Button onClick={nextStep} disabled={!isEnabled('nextStep')} className='btn btn--oval btn--colored btn--small'>Next</Button>
                <Button onClick={saveDraft} disabled={!saveEnabled && !cartId} className='btn btn--oval btn--colored btn--small'>Save</Button>

                {/* <ToastContainer /> */}
            </div>
            {/* </View> */}
            {
                open &&
                <BaseComponent id="25983496" callback={callback}></BaseComponent>
            }
        </div>
    );
    // }
}
